const routes = [];

class ORoute {
  constructor(element, routesNavElement) {
    const { id } = element;
    const navLinkElement = routesNavElement.querySelector(`a[href="#${id}"]`);

    this.element = element;
    this.id = id;
    this.navLinkElement = navLinkElement;

    const observer = new IntersectionObserver(
      (entries) => {
        const { mMapRoute } = window;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            navLinkElement.classList.add('-active');
            navLinkElement.scrollIntoView({
              behavior: 'smooth',
            });
          } else {
            navLinkElement.classList.remove('-active');
          }

          // show first active route on map or show all routes
          const firstActiveNavLinkElement = routesNavElement.querySelector('a.-active');
          if (firstActiveNavLinkElement) {
            const firstActiveId = firstActiveNavLinkElement.getAttribute('href').substr(1);
            if (mMapRoute.isLoaded) {
              mMapRoute.focusRoute(firstActiveId);
            } else {
              mMapRoute.map.on('load', () => {
                setTimeout(() => {
                  mMapRoute.focusRoute(firstActiveId);
                }, 500);
              });
            }
          } else if (mMapRoute?.isLoaded) {
            mMapRoute.removeFocus();
          }
        });
      },
      {
        rootMargin: '-40px 0px -100px',
      },
    );
    observer.observe(element);
  }
}

const routesContainerElement = document.querySelector('.o-routes__routes-container');
const routesNavElement = document.querySelector('.m-routes-nav');
const routesNavToTopElement = document.querySelector('.m-routes-nav__to-top');
[...document.querySelectorAll('.o-routes .o-route')].forEach((element) => {
  routes.push(new ORoute(element, routesNavElement));
});

if (routesContainerElement) {
  document.addEventListener('scroll', () => {
    const {
      offsetTop,
    } = routesContainerElement;
    const showNav = document.scrollingElement.scrollTop > offsetTop - window.innerHeight * 0.8;
    routesNavElement?.classList.toggle('-hidden', !showNav);
    routesNavToTopElement?.classList.toggle('-hidden', !showNav);
    if (showNav) {
      window.mMapRoute?.map?.cooperativeGestures.disable();
    } else {
      window.mMapRoute?.map?.cooperativeGestures.enable();
    }
  }, {
    passive: true,
  });
}
